import { Grid } from '@material-ui/core';
import { Field, Form, FormElement } from '@progress/kendo-react-form';
import React, { useEffect, useState } from 'react'
import { ButtonHLPure, HeaderHLPure } from '../../../pures';
import { useTranslation } from 'react-i18next';
import InputPureWrapper from './inputs/inputPureWrapper';
import { RegistrationValidator } from '../../../../validators';

function PersonalDataForm(props) {
    const {
        user,
        moveStep,
        onSubmitStep
    } = props;

    const { t } = useTranslation()
    const { t: tCommon } = useTranslation('common')
    const validator = RegistrationValidator(t)

    const [loading, setLoading] = useState(true)
    const [initialValues, setInitialValues] = useState({})

    useEffect(() => {
        if (user) {
            setInitialValues({
                firstName: user.firstName,
                firstLastName: user.firstLastName,
                secondLastName: user.secondLastName,
                phoneNumber: user.phoneNumber
            })
        }
        setLoading(false)
    }, [user])

    return (
        <Form
            key={`personalDataForm-${loading}`}
            onSubmitClick={(e) => {
                if (!e.isValid) return;

                if (e.isModified) {
                    onSubmitStep(e.values)
                } else {
                    if (initialValues.firstName && initialValues.firstLastName && initialValues.secondLastName) {
                        // user had already saved this data
                        moveStep(true)
                    }
                }
            }}
            initialValues={initialValues}
            render={(formRenderProps) => {
                return (
                    <FormElement>
                        <Grid container className='personalDataForm' spacing={3}>
                            <Grid item xs={12}>
                                <HeaderHLPure title={t("register.personalData")} headingNumber={2} />
                            </Grid>

                            <Grid item xs={12}>
                                <Field
                                    id="firstName"
                                    name={'firstName'}
                                    component={InputPureWrapper}
                                    label={t('register.personalData.name')}
                                    validator={validator.nameValidator}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Field
                                    id="firstLastName"
                                    name={'firstLastName'}
                                    component={InputPureWrapper}
                                    label={t('register.personalData.firstLastName')}
                                    validator={validator.firstLastNameValidator}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Field
                                    id="secondLastName"
                                    name={'secondLastName'}
                                    component={InputPureWrapper}
                                    label={t('register.personalData.secoundLastName')}
                                    validator={validator.secondLastNameValidator}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Field
                                    id="phoneNumber"
                                    name={'phoneNumber'}
                                    component={InputPureWrapper}
                                    label={t('register.personalData.phone')}
                                    validator={validator.phoneValidator}
                                />
                            </Grid>

                            <Grid item xs={12} className='onboardingView-actions'>
                                {/* <ButtonHLPure colorScheme="error" outlined nameBtn={tCommon("back")} onClick={() => moveStep(false)} /> */}
                                <ButtonHLPure type="submit" colorScheme="primary" outlined nameBtn={tCommon("continue")} />
                            </Grid>
                        </Grid>
                    </FormElement>
                )
            }}
        />
    )
}

export default PersonalDataForm